export default "__VITE_ASSET__da00c734__"